import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import performRequest from "../../../api/request";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import { QuotationMatrixInfo } from "../../../SchemaInfo/info";
import { FcPuzzle } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { QuotationMatrixSchema } from "../../../Schemas/quotation/quotation_matrix_schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";

const EditQuotationMatrix = () => {
  const [matrixInfo, setMatrixInfo] = useState(QuotationMatrixInfo);
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState("");
  let { id } = useParams();
  const navigate = useNavigate();
  const handelSubmit = (values) => {
    setEditData(values);
    document.getElementById("open-modal").click();
  };
  const handelEdit = (values) => {
    setLoading(true);
    performRequest(
      "PATCH",
      `/quotationMatrix/updateQuotationMatrix/${id}`,
      values
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Quotation updated successfully!");
          navigate(`/standard-quotation/view/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/quotationMatrix/getQuotationMatrixById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setMatrixInfo(res.data);
        } else {
          Toast("error", "Error while getting client expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const getPercentage401_500 = (factor) => {
    switch (factor) {
      case "nethouse":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };

      case "fanpad":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };

      case "nvph":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };

      case "a-frame":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "flatbed":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "growbags":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "dutchbucket":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "growers-combo":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "air-circulations-fans":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "electric-panels-electric-fittings":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "iot-automation-and-display":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "engineering-Errection-and-commissioning-cea-nvph":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-nvph-soilbased":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad-soilbased":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse-soilbased":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };

      case "engineering-Errection-and-commissioning-cea-nvph-soilbased":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad-soilbased":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse-soilbased":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };

      case "engineering-errection-and-commissioning-hydroponics-af-fb":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };
      case "engineering-errection-and-commissioning-hydroponics-gb-db":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };

      case "mechanical-geared-vent-operator":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "ground-cover-weedmat-grade-a-110gsm":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "retractable-aluminum-net":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "manufacturing-charges-hydroponics":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "manufacturing-charges-cea":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "fogger-system":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };

      case "drip-system":
        return {
          percent1: 0.05,
          percent2: 0.12,
          percent3: 0.18,
        };

      case "nethouse only":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };
      case "fanpad only":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };
      case "nvph only":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };

      case "nethouse soilbased":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };
      case "fanpad soilbased":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };
      case "nvph soilbased":
        return {
          percent1: 0.02,
          percent2: 0.072,
          percent3: 0.125,
        };

      case "hydroponic-plumbing":
        return {
          percent1: 0.13,
          percent2: 0.28,
          percent3: 0.42,
        };
      case "labour-additional-fixed-cost":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      case "kryzen-biotech-admin-cost":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      case "kryzen-biotech-consulting-cost":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      default:
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
    }
  };
  const getPercentage1001_1500 = (factor, slab = "1000-1500") => {
    if (slab === "1000-1500") {
      switch (factor) {
        case "nethouse":
          return 0.1;

        case "fanpad":
          return 0.1;

        case "nvph":
          return 0.1;

        case "a-frame":
          return 0;

        case "flatbed":
          return 0;

        case "growbags":
          return 0;

        case "dutchbucket":
          return 0;

        case "growers-combo":
          return 0;

        case "air-circulations-fans":
          return 0;

        case "electric-panels-electric-fittings":
          return 0;

        case "iot-automation-and-display":
          return 0;

        case "engineering-Errection-and-commissioning-cea-nvph":
          return 0.1;

        case "engineering-Errection-and-commissioning-cea-fanpad":
          return 0.1;

        case "engineering-Errection-and-commissioning-cea-nethouse":
          return 0.1;

        case "engineering-Errection-and-commissioning-cea-nvph-soilbased":
          return 0.1;

        case "engineering-Errection-and-commissioning-cea-fanpad-soilbased":
          return 0.1;

        case "engineering-Errection-and-commissioning-cea-nethouse-soilbased":
          return 0.1;

        case "engineering-errection-and-commissioning-hydroponics-af-fb":
          return 0.1;

        case "engineering-errection-and-commissioning-hydroponics-gb-db":
          return 0.1;

        case "mechanical-geared-vent-operator":
          return 0;

        case "ground-cover-weedmat-grade-a-110gsm":
          return 0;

        case "retractable-aluminum-net":
          return 0;

        case "manufacturing-charges-hydroponics":
          return 0;

        case "manufacturing-charges-cea":
          return 0;

        case "fogger-system":
          return 0.04;

        case "drip-system":
          return 0.04;

        case "nethouse only":
          return 0.1;

        case "fanpad only":
          return 0.1;

        case "nvph only":
          return 0.1;

        case "nethouse soilbased":
          return 0.1;

        case "fanpad soilbased":
          return 0.1;

        case "nvph soilbased":
          return 0.1;

        case "hydroponic-plumbing":
          return 0.2;

        case "labour-additional-fixed-cost":
          return 0.5;

        case "kryzen-biotech-admin-cost":
          return 0;

        case "kryzen-biotech-consulting-cost":
          return 1;

        default:
          return 0;
      }
    } else {
      switch (factor) {
        case "nethouse":
          return 0.01;

        case "fanpad":
          return 0.01;

        case "nvph":
          return 0.03;

        case "a-frame":
          return 0;

        case "flatbed":
          return 0;

        case "growbags":
          return 0;

        case "dutchbucket":
          return 0;

        case "growers-combo":
          return 0;

        case "air-circulations-fans":
          return 0;

        case "electric-panels-electric-fittings":
          return 0;

        case "iot-automation-and-display":
          return 0;

        case "engineering-Errection-and-commissioning-cea-nvph":
          return 0.05;

        case "engineering-Errection-and-commissioning-cea-fanpad":
          return 0.05;

        case "engineering-Errection-and-commissioning-cea-nethouse":
          return 0.05;

        case "engineering-Errection-and-commissioning-cea-nvph-soilbased":
          return 0.05;

        case "engineering-Errection-and-commissioning-cea-fanpad-soilbased":
          return 0.05;

        case "engineering-Errection-and-commissioning-cea-nethouse-soilbased":
          return 0.05;

        case "engineering-errection-and-commissioning-hydroponics-af-fb":
          return 0.05;

        case "engineering-errection-and-commissioning-hydroponics-gb-db":
          return 0.05;

        case "mechanical-geared-vent-operator":
          return 0;

        case "ground-cover-weedmat-grade-a-110gsm":
          return 0;

        case "retractable-aluminum-net":
          return 0;

        case "manufacturing-charges-hydroponics":
          return 0;

        case "manufacturing-charges-cea":
          return 0;

        case "fogger-system":
          return 0.04;

        case "drip-system":
          return 0.07;

        case "nethouse only":
          return 0.01;

        case "fanpad only":
          return 0.01;

        case "nvph only":
          return 0.03;

        case "nethouse soilbased":
          return 0.01;

        case "fanpad soilbased":
          return 0.01;

        case "nvph soilbased":
          return 0.03;

        case "hydroponic-plumbing":
          return 0.33;

        case "labour-additional-fixed-cost":
          return 0;

        case "kryzen-biotech-admin-cost":
          return 0;

        case "kryzen-biotech-consulting-cost":
          return 0;

        default:
          return 0;
      }
    }
  };
  const getPercentage3501_4000 = (factor) => {
    switch (factor) {
      case "nethouse":
        return {
          percent1: 0.02,
          percent2: 0.05,
        };

      case "fanpad":
        return {
          percent1: 0.02,
          percent2: 0.05,
        };

      case "nvph":
        return {
          percent1: 0.02,
          percent2: 0.028,
        };

      case "a-frame":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "flatbed":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "growbags":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "dutchbucket":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "growers-combo":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "air-circulations-fans":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "electric-panels-electric-fittings":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "iot-automation-and-display":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "engineering-Errection-and-commissioning-cea-nvph":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };
      case "engineering-Errection-and-commissioning-cea-nvph-soilbased":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad-soilbased":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse-soilbased":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };

      case "engineering-errection-and-commissioning-hydroponics-af-fb":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };
      case "engineering-errection-and-commissioning-hydroponics-gb-db":
        return {
          percent1: 0.035,
          percent2: 0.07,
        };

      case "mechanical-geared-vent-operator":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "ground-cover-weedmat-grade-a-110gsm":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "retractable-aluminum-net":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "manufacturing-charges-hydroponics":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "manufacturing-charges-cea":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "fogger-system":
        return {
          percent1: 0.035,
          percent2: 0.06,
        };

      case "drip-system":
        return {
          percent1: 0.07,
          percent2: 0.13,
        };

      case "nethouse only":
        return {
          percent1: 0.02,
          percent2: 0.05,
        };

      case "fanpad only":
        return {
          percent1: 0.02,
          percent2: 0.05,
        };

      case "nvph only":
        return {
          percent1: 0.02,
          percent2: 0.028,
        };

      case "nethouse soilbased":
        return {
          percent1: 0.02,
          percent2: 0.05,
        };

      case "fanpad soilbased":
        return {
          percent1: 0.02,
          percent2: 0.05,
        };

      case "nvph soilbased":
        return {
          percent1: 0.02,
          percent2: 0.028,
        };

      case "hydroponic-plumbing":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "labour-additional-fixed-cost":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "kryzen-biotech-admin-cost":
        return {
          percent1: 0,
          percent2: 0,
        };

      case "kryzen-biotech-consulting-cost":
        return {
          percent1: 0,
          percent2: 0,
        };

      default:
        return {
          percent1: 0,
          percent2: 0,
        };
    }
  };
  const getPercentage5501_6000 = (factor) => {
    switch (factor) {
      case "nethouse":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "fanpad":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "nvph":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "a-frame":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "flatbed":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "growbags":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "dutchbucket":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "growers-combo":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "air-circulations-fans":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "electric-panels-electric-fittings":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "iot-automation-and-display":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "engineering-Errection-and-commissioning-cea-nvph":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse":
        return {
          percent1: 0,
          percent2: 0.05,
          percent3: 0.1,
        };

      case "engineering-Errection-and-commissioning-cea-nvph-soilbased":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      case "engineering-Errection-and-commissioning-cea-fanpad-soilbased":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
      case "engineering-Errection-and-commissioning-cea-nethouse-soilbased":
        return {
          percent1: 0,
          percent2: 0.05,
          percent3: 0.1,
        };

      case "engineering-errection-and-commissioning-hydroponics-af-fb":
        return {
          percent1: 0.0,
          percent2: 0.02,
          percent3: 0.03,
        };
      case "engineering-errection-and-commissioning-hydroponics-gb-db":
        return {
          percent1: 0.0,
          percent2: 0.02,
          percent3: 0.03,
        };

      case "mechanical-geared-vent-operator":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "ground-cover-weedmat-grade-a-110gsm":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "retractable-aluminum-net":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "manufacturing-charges-hydroponics":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "manufacturing-charges-cea":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "fogger-system":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "drip-system":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "nethouse only":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "fanpad only":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "nvph only":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "nethouse soilbased":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "fanpad soilbased":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "nvph soilbased":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "hydroponic-plumbing":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "labour-additional-fixed-cost":
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };

      case "kryzen-biotech-admin-cost":
        return {
          percent1: -0.3334,
          percent2: -0.3334,
          percent3: -0.3334,
        };

      case "kryzen-biotech-consulting-cost":
        return {
          percent1: 0.33,
          percent2: 0.33,
          percent3: 0.33,
        };

      default:
        return {
          percent1: 0,
          percent2: 0,
          percent3: 0,
        };
    }
  };

  const calculateCost401_500 = (props, val, key1, key2, key3) => {
    let { percent1, percent2, percent3 } = getPercentage401_500(
      props.values.factor
    );
    console.log(percent1, percent2, percent3, props.values.factor);
    let calVal = +val;
    let calVal1 = Math.ceil(calVal + calVal * percent1);
    props.setFieldValue(key1, calVal1);
    let calVal2 = Math.ceil(calVal + calVal * percent2);
    props.setFieldValue(key2, calVal2);
    let calVal3 = Math.ceil(calVal + calVal * percent3);
    props.setFieldValue(key3, calVal3);
    return;
  };
  const calculateCost1001_1500 = (props, val, key, slab = "1000-1500") => {
    let percent = getPercentage1001_1500(props.values.factor, slab);
    let calVal = +val;
    calVal = Math.ceil(calVal + calVal * percent);
    props.setFieldValue(key, calVal);

    return;
  };
  const calculateCost3501_4000 = (props, val, key1, key2) => {
    let { percent1, percent2 } = getPercentage3501_4000(props.values.factor);
    let calVal = +val;
    let calVal1 = Math.ceil(calVal + calVal * percent1);
    props.setFieldValue(key1, calVal1);
    let calVal2 = Math.ceil(calVal + calVal * percent2);
    props.setFieldValue(key2, calVal2);

    return;
  };
  const calculateCost5501_6000 = (props, val, key1, key2, key3) => {
    let { percent1, percent2, percent3 } = getPercentage5501_6000(
      props.values.factor
    );
    let calVal1 = +val;
    props.setFieldValue(key1, Math.ceil(calVal1 + calVal1 * percent1));
    let calVal2 = Math.ceil(calVal1 + calVal1 * percent2);
    props.setFieldValue(key2, calVal2);
    let calVal3 = Math.ceil(calVal1 + calVal1 * percent3);
    props.setFieldValue(key3, calVal3);
    return;
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPuzzle className="fs-2  me-1" /> Edit Quotation Matrix
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Base values that affect quotation
                  pricing.
                </h4>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  Only Super admins and admins can make changes to quotation
                  matrix. This will directly affect the quotations we are
                  sending to clients.
                </p>
                <p>
                  If you are not authorized, do not make any changes to this.
                </p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={matrixInfo}
                  validationSchema={QuotationMatrixSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Type
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="type" disabled />

                            {props.touched.type && props.errors.type && (
                              <p className="text-danger">{props.errors.type}</p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Factor
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="factor"
                              disabled
                            ></CustomInput>
                            {props.touched.factor && props.errors.factor && (
                              <p className="text-danger">
                                {props.errors.factor}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Unit
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="unit"
                              disabled
                            ></CustomInput>
                            {props.touched.unit && props.errors.unit && (
                              <p className="text-danger">{props.errors.unit}</p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Description
                          </label>
                          <div className="w-100 col">
                            <CustomTextArea
                              type="textarea"
                              rows={4}
                              name="description"
                            />
                            {props.touched.description &&
                              props.errors.description && (
                                <p className="text-danger">
                                  {props.errors.description}
                                </p>
                              )}
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 0-500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice401To500"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue("basePrice401To500", val);
                                calculateCost401_500(
                                  props,
                                  val,
                                  "basePrice201To400",
                                  "basePrice101To200",
                                  "basePrice0To100"
                                );
                              }}
                            />
                            {props.touched.basePrice401To500 &&
                              props.errors.basePrice401To500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice401To500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 1001-1500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice1001To1500"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue("basePrice1001To1500", val);
                                calculateCost1001_1500(
                                  props,
                                  val,
                                  "basePrice501To1000"
                                );
                              }}
                            />
                            {props.touched.basePrice1001To1500 &&
                              props.errors.basePrice1001To1500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice1001To1500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 2001-2500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice2001To2500"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue("basePrice2001To2500", val);
                                calculateCost1001_1500(
                                  props,
                                  val,
                                  "basePrice1501To2000",
                                  "2001-2500"
                                );
                              }}
                            />
                            {props.touched.basePrice2001To2500 &&
                              props.errors.basePrice2001To2500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice2001To2500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 3501-4000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice3501To4000"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue("basePrice3501To4000", val);
                                calculateCost3501_4000(
                                  props,
                                  val,
                                  "basePrice3001To3500",
                                  "basePrice2501To3000"
                                );
                              }}
                            />
                            {props.touched.basePrice3501To4000 &&
                              props.errors.basePrice3501To4000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice3501To4000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 5501-6000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice5501To6000"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue("basePrice5501To6000", val);
                                props.setFieldValue("basePrice6001To6500", val);
                                props.setFieldValue("basePrice6501To7000", val);
                                props.setFieldValue("basePrice7001To7500", val);
                                props.setFieldValue("basePrice7501To8000", val);
                                props.setFieldValue(
                                  "basePriceGreater8000",
                                  val
                                );
                                calculateCost5501_6000(
                                  props,
                                  val,
                                  "basePrice5001To5500",
                                  "basePrice4501To5000",
                                  "basePrice4001To4500"
                                );
                              }}
                            />
                            {props.touched.basePrice5501To6000 &&
                              props.errors.basePrice5501To6000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice5501To6000}
                                </p>
                              )}
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 0-200
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent0To100"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue("markupPercent0To100", val);
                                props.setFieldValue(
                                  "markupPercent101To200",
                                  val
                                );
                              }}
                            />
                            {props.touched.markupPercent0To100 &&
                              props.errors.markupPercent0To100 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent0To100}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 201-400
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent201To400"
                              type="text"
                            />
                            {props.touched.markupPercent201To400 &&
                              props.errors.markupPercent201To400 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent201To400}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 401-500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent401To500"
                              type="text"
                            />
                            {props.touched.markupPercent401To500 &&
                              props.errors.markupPercent401To500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent401To500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 501-1500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent501To1000"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;

                                props.setFieldValue(
                                  "markupPercent501To1000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent1001To1500",
                                  val
                                );
                              }}
                            />
                            {props.touched.markupPercent501To1000 &&
                              props.errors.markupPercent501To1000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent501To1000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 1501-2500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent1501To2000"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;

                                props.setFieldValue(
                                  "markupPercent1501To2000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent2001To2500",
                                  val
                                );
                              }}
                            />
                            {props.touched.markupPercent1501To2000 &&
                              props.errors.markupPercent1501To2000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent1501To2000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 2501-6000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent2501To3000"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue(
                                  "markupPercent2501To3000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent3001To3500",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent3501To4000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent4001To4500",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent4501To5000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent5001To5500",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent5501To6000",
                                  val
                                );
                              }}
                            />
                            {props.touched.markupPercent2501To3000 &&
                              props.errors.markupPercent2501To3000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent2501To3000}
                                </p>
                              )}
                          </div>
                        </div>{" "}
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 6501-7000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent6001To6500"
                              type="text"
                              onChange={(e) => {
                                let val = e.target.value;
                                props.setFieldValue(
                                  "markupPercent6001To6500",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent6501To7000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent7001To7500",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercent7501To8000",
                                  val
                                );
                                props.setFieldValue(
                                  "markupPercentGreater8000",
                                  val
                                );
                              }}
                            />
                            {props.touched.markupPercent6001To6500 &&
                              props.errors.markupPercent6001To6500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent6001To6500}
                                </p>
                              )}
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 0-100
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice0To100"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice0To100 &&
                              props.errors.basePrice0To100 && (
                                <p className="text-danger">
                                  {props.errors.basePrice0To100}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 101-200
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice101To200"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice101To200 &&
                              props.errors.basePrice101To200 && (
                                <p className="text-danger">
                                  {props.errors.basePrice101To200}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 201-400
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice201To400"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice201To400 &&
                              props.errors.basePrice201To400 && (
                                <p className="text-danger">
                                  {props.errors.basePrice201To400}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 401-500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice401To500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice401To500 &&
                              props.errors.basePrice401To500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice401To500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 501-1000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice501To1000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice501To1000 &&
                              props.errors.basePrice501To1000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice501To1000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 1001-1500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice1001To1500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice1001To1500 &&
                              props.errors.basePrice1001To1500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice1001To1500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 1501-2000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice1501To2000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice1501To2000 &&
                              props.errors.basePrice1501To2000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice1501To2000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 2001-2500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice2001To2500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice2001To2500 &&
                              props.errors.basePrice2001To2500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice2001To2500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 2501-3000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice2501To3000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice2501To3000 &&
                              props.errors.basePrice2501To3000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice2501To3000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 3001-3500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice3001To3500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice3001To3500 &&
                              props.errors.basePrice3001To3500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice3001To3500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 3501-4000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice3501To4000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice3501To4000 &&
                              props.errors.basePrice3501To4000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice3501To4000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 4001-4500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice4001To4500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice4001To4500 &&
                              props.errors.basePrice4001To4500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice4001To4500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 4501-5000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice4501To5000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice4501To5000 &&
                              props.errors.basePrice4501To5000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice4501To5000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 5001-5500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice5001To5500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice5001To5500 &&
                              props.errors.basePrice5001To5500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice5001To5500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 5501-6000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice5501To6000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice5501To6000 &&
                              props.errors.basePrice5501To6000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice5501To6000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 6001-6500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice6001To6500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice6001To6500 &&
                              props.errors.basePrice6001To6500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice6001To6500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 6501-7000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice6501To7000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice6501To7000 &&
                              props.errors.basePrice6501To7000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice6501To7000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 7001-7500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice7001To7500"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice7001To7500 &&
                              props.errors.basePrice7001To7500 && (
                                <p className="text-danger">
                                  {props.errors.basePrice7001To7500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 7501-8000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePrice7501To8000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePrice7501To8000 &&
                              props.errors.basePrice7501To8000 && (
                                <p className="text-danger">
                                  {props.errors.basePrice7501To8000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Base price 8000+
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="basePriceGreater8000"
                              type="text"
                              disabled
                            />
                            {props.touched.basePriceGreater8000 &&
                              props.errors.basePriceGreater8000 && (
                                <p className="text-danger">
                                  {props.errors.basePriceGreater8000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Weedmat
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sqMtrWeed"
                              type="text"
                              disabled
                            />
                            {props.touched.sqMtrWeed &&
                              props.errors.sqMtrWeed && (
                                <p className="text-danger">
                                  {props.errors.sqMtrWeed}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 0-100
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent0To100"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent0To100 &&
                              props.errors.markupPercent0To100 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent0To100}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 101-200
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent101To200"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent101To200 &&
                              props.errors.markupPercent101To200 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent101To200}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 201-400
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent201To400"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent201To400 &&
                              props.errors.markupPercent201To400 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent201To400}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 401T-500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent401To500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent401To500 &&
                              props.errors.markupPercent401To500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent401To500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 501-1000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent501To1000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent501To1000 &&
                              props.errors.markupPercent501To1000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent501To1000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 1001-1500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent1001To1500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent1001To1500 &&
                              props.errors.markupPercent1001To1500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent1001To1500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 1501-2000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent1501To2000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent1501To2000 &&
                              props.errors.markupPercent1501To2000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent1501To2000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 2001-2500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent2001To2500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent2001To2500 &&
                              props.errors.markupPercent2001To2500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent2001To2500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 2501-3000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent2501To3000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent2501To3000 &&
                              props.errors.markupPercent2501To3000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent2501To3000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 3001-3500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent3001To3500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent3001To3500 &&
                              props.errors.markupPercent3001To3500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent3001To3500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 3501-4000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent3501To4000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent3501To4000 &&
                              props.errors.markupPercent3501To4000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent3501To4000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 4001-4500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent4001To4500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent4001To4500 &&
                              props.errors.markupPercent4001To4500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent4001To4500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 4501-5000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent4501To5000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent4501To5000 &&
                              props.errors.markupPercent4501To5000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent4501To5000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 5001-5500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent5001To5500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent5001To5500 &&
                              props.errors.markupPercent5001To5500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent5001To5500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 5501-6000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent5501To6000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent5501To6000 &&
                              props.errors.markupPercent5501To6000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent5501To6000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 6001-6500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent6001To6500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent6001To6500 &&
                              props.errors.markupPercent6001To6500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent6001To6500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 6501-7000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent6501To7000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent6501To7000 &&
                              props.errors.markupPercent6501To7000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent6501To7000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 7001-7500
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent7001To7500"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent7001To7500 &&
                              props.errors.markupPercent7001To7500 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent7001To7500}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 7501-8000
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercent7501To8000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercent7501To8000 &&
                              props.errors.markupPercent7501To8000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercent7501To8000}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Markup 8000+
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="markupPercentGreater8000"
                              type="text"
                              disabled
                            />
                            {props.touched.markupPercentGreater8000 &&
                              props.errors.markupPercentGreater8000 && (
                                <p className="text-danger">
                                  {props.errors.markupPercentGreater8000}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Save Quotation Matrix" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-danger"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <span
                id="open-modal"
                data-bs-toggle="modal"
                data-bs-target="#modal-danger"
              ></span>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-status bg-warning"></div>
              <div className="modal-body text-center py-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon mb-2 text-warning icon-lg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z" />
                  <path d="M12 9v4" />
                  <path d="M12 17h.01" />
                </svg>
                <h3>Are you sure about edit Quotation Matrix?</h3>
                <div className="text-muted">
                  Do you really want to update base values? This will directly
                  affect on the final values of quotations.
                </div>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn w-100" data-bs-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                    <div className="col">
                      <button
                        className="btn btn-warning w-100"
                        data-bs-dismiss="modal"
                        onClick={() => handelEdit(editData)}
                      >
                        Save Values
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditQuotationMatrix;
